__turbopack_context__.v({
  "autoMaxHeight": "index-module__I8VvDW__autoMaxHeight",
});
